import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { JwtLegFiClaims } from '../../services/auth/jwt-legfi-claims.model';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'lf-app-layout',
    styleUrls: ['../../app.component.scss'],
    templateUrl: './app-layout.component.html',
})
export class AppLayoutComponent implements OnInit, AfterViewInit
{
    jwt: JwtLegFiClaims;
    isLoggedIn: boolean = false;
    bannerShowing = false;
    isInMobileMode = false;

    @ViewChild(MatSidenav) sidenav!: MatSidenav;

    constructor(
            private _observer: BreakpointObserver,
            private _router: Router,
    ) {
    }

    ngOnInit() {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();

        if (jwt !== null && !jwt.superUser) {
            this.jwt = jwt;
            this.isLoggedIn = true;
        } else {
            this.jwt = null;
            this.isLoggedIn = false;
        }
    }

    /** Set up mat sidebar / menu functionality based on screen width */
    ngAfterViewInit() {
        setTimeout(() => {
            this._observer.observe(['(max-width: 945px)']).subscribe((res) => {
                if (res.matches) {
                    this.sidenav.mode = 'over';
                    this.sidenav.close().then(() => {
                        this.isInMobileMode = true;
                    });

                } else {
                    this.sidenav.mode = 'side';
                    this.sidenav.open().then(() => {
                        this.isInMobileMode = false;
                    });
                }
            });
        });
    }

    // if the page is in mobile view, they clicked to change routes; toggle the sidenav
    handleSidenavClickOnMobile(): void {
        if (this.sidenav.mode === 'over') {
            this.sidenav.close();
        }
    }

    updateBannerStatus(showing: boolean) {
        this.bannerShowing = showing;
    }
}
